import { render, staticRenderFns } from "./ModalChatFeedback.vue?vue&type=template&id=90c2657a&scoped=true"
import script from "./ModalChatFeedback.vue?vue&type=script&lang=js"
export * from "./ModalChatFeedback.vue?vue&type=script&lang=js"
import style0 from "./ModalChatFeedback.vue?vue&type=style&index=0&id=90c2657a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c2657a",
  null
  
)

export default component.exports